export default __webpack_public_path__ + "static/media/App.50f0ce81.less";